import u from "prop-types";
const d = (i) => (o, c = "", s = null) => (r, e, n, t) => {
  i === "deprecated" ? e in r && ![s, void 0, null].includes(r[e]) && console.warn(
    `Warning: Failed prop type: Prop ${e} in component ${n} has been deprecated.
${c}`
  ) : i === "required" && (r[e] || console.warn(
    `Warning: The prop ${e} will be required in ${n} in the next MRUI major release.
${c}`
  ));
  try {
    u.checkPropTypes(
      { [e]: o },
      r,
      t,
      n
    );
  } catch (l) {
    console.warn(l.message);
  }
}, f = d("deprecated"), y = d("required");
export {
  f as d,
  y as f
};
